import { minutesToMilliseconds } from 'date-fns';

export * from './appTheme';
export * from './navItems';
export * from './dialogMap';
export * from './interceptors';
export * from './appConfig.service';

export const OTP_TTL = minutesToMilliseconds(1);
export const MAX_OTP_RETRIES = 5;
